import api from '../utils/api';

export async function listScheduledMessages(agentId, {
  page = 1,
  perPage = 20,
  status = null,
  search = null,
  recurrencePreset = null,
  recurrenceDays = null,
} = {}) {
  const params = { page, per_page: perPage };
  if (status) {
    params.status = status;
  }
  if (search) {
    params.search = search;
  }
  if (recurrenceDays) {
    params.recurrence_days = recurrenceDays;
  } else if (recurrencePreset) {
    params.recurrence_preset = recurrencePreset;
  }
  const { data } = await api.get(`/agents/${agentId}/scheduled-messages`, { params });
  return data;
}

export async function listRecurrenceDayPatterns(agentId) {
  const { data } = await api.get(`/agents/${agentId}/scheduled-messages/recurrence-patterns`);
  return data;
}

export async function getScheduledMessage(id) {
  const { data } = await api.get(`/scheduled-messages/${id}`);
  return data;
}

export async function createScheduledMessage(agentId, payload) {
  const { data } = await api.post(`/agents/${agentId}/scheduled-messages`, payload);
  return data;
}

export async function cancelScheduledMessage(id) {
  const { data } = await api.post(`/scheduled-messages/${id}/cancel`);
  return data;
}

export async function deleteScheduledMessage(id) {
  const { data } = await api.delete(`/scheduled-messages/${id}`);
  return data;
}

export async function retryScheduledMessage(id) {
  const { data } = await api.post(`/scheduled-messages/${id}/retry`);
  return data;
}

export async function resendScheduledMessage(id) {
  const { data } = await api.post(`/scheduled-messages/${id}/resend`);
  return data;
}

export async function forceDispatchScheduledMessage(id) {
  const { data } = await api.post(`/scheduled-messages/${id}/dispatch-now`);
  return data;
}

export async function sendScheduledMessageTemplate(id) {
  const { data } = await api.post(`/scheduled-messages/${id}/send-template`);
  return data;
}

export async function updateScheduledMessage(id, payload) {
  const { data } = await api.patch(`/scheduled-messages/${id}`, payload);
  return data;
}
